import { render } from "./HandleViewContent.vue?vue&type=template&id=e5c3d7b8"
import script from "./HandleViewContent.vue?vue&type=script&lang=js"
export * from "./HandleViewContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__